<template>
    <rkm-row>
        <rkm-col cols="4">
            <rkm-form-select
                label="Cuidador"
                :options="form.cuidador"
                v-model="model.cuidador"
                value-field="id"
                text-field="descricao"
                :disabled="model.exportacao"
            />
        </rkm-col>

        <rkm-col cols="4" v-if="model.cuidador != 1">
            <rkm-form-input
                label="CNS"
                v-model="model.cuidadorCns"
                v-mask="mask.cns"
                :validations="validations.cns"
                :disabled="model.exportacao || model.cuidadorCpf.length > 0"
            />
        </rkm-col>

        <rkm-col cols="4" v-if="model.cuidador != 1">
            <rkm-form-input
                label="CPF"
                v-model="model.cuidadorCpf"
                v-mask="mask.cpf"
                :validations="validations.cpf"
                :disabled="model.exportacao || model.cuidadorCns.length > 0"
            />
        </rkm-col>
    </rkm-row>
</template>

<script>
import { mask, object } from '@/mixins'

export default {
    mixins: [ mask, object ],
    computed: {
        validations() {
            return {
                cns: {
                    min_max_without_mask: 15,
                    cns: true,
                    required: true,
                    not_same: this.model.cidadao.cns
                },
                cpf: {
                    min_max_without_mask: 11,
                    cpf: true,
                    required: true,
                    not_same: this.model.cidadao.cpf
                }
            }
        }
    },
    props: {
        model: { type: Object, required: false, },
        form: { type: Object, required: false, },
    },
}
</script>